// @flow
import Impressions from 'app/packages/impression-logging/Impressions';

export { HIGH_PRIORITY, LOW_PRIORITY } from 'app/packages/impression-logging/Impressions';
export default new Impressions();
